/* eslint-disable no-nested-ternary */
// material
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
// component
import { ReactComponent as PhotoPlaceholder } from '../../../assets/ic_photo_placeholder.svg';
import { FlowTypes } from '../../../entities/flow-type'

const Validation = styled(Typography)(({ theme, state }) => ({
    color: state === '1' ? theme.palette.success.main : state === '2' ? theme.palette.info.main : theme.palette.error.main,
}));

const Attachment = styled(Typography)(({ theme, state }) => ({
    color: state === 'true' ? theme.palette.primary.main : theme.palette.text.primary,
    cursor: state === 'true' ? 'pointer' : 'default',
    '&:hover': {
        textDecoration: state === 'true' ? 'underline' : 'none',
    },
}));

export default function generate({ t, onSee, controlFlowType = { name: FlowTypes.SEQUENTIAL }, onImageClick }) {
    return controlFlowType.name === FlowTypes.SEQUENTIAL ? [
        {
            name: 'Item.photos',
            label: t('items.items.icon'),
            options: {
                customBodyRender: (val) => (
                    val.length > 0 ?
                        <div
                            role="button"
                            tabIndex={0}
                            style={{ width: 50, height: 50, borderRadius: 5, cursor: 'pointer', display: 'inline-block' }}
                            onClick={() => {
                                if (onImageClick) {
                                    onImageClick(val);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    if (onImageClick) {
                                        onImageClick(val);
                                    }
                                }
                            }}
                            aria-label="View image gallery"
                        >
                            <img
                                src={val[0]}
                                alt='Item thumbnail'
                                style={{ width: '100%', height: '100%', borderRadius: 5, objectFit: 'cover' }}
                            />
                        </div> :
                        <PhotoPlaceholder width={28} style={{ marginLeft: '10px' }} />
                ),
            },
        },
        {
            name: 'Item.title',
            label: t('items.items.identifier'),
        },
        {
            name: 'conformity.id',
            label: t('inspections.info-card.complaint'),
            options: {
                customBodyRender: (val) => {
                    let text = t('inspections.items.no')
                    if (val === 1) {
                        text = t('inspections.items.yes')
                    } else if (val === 2) {
                        text = t('inspections.items.scheduled')
                    }
                    return <Validation state={val.toString()}>{text}</Validation>
                },
            },
        },
        {
            name: 'description',
            label: t('items.items.description'),
            options: {
                customBodyRender: (val) => (
                    <div style={{ maxHeight: '180px', overflowY: 'auto' }}>
                        {val && val}
                    </div>
                ),
            },
        },
        {
            name: 'photos',
            label: t('inspections.items.attachments', { number: '' }),
            options: {
                customBodyRender: (val) => {
                    if (val.length > 0) {
                        if (val.length === 1) {
                            return (
                                <Attachment
                                    state={(val.length > 0).toString()}
                                    onClick={() => onSee(val)}
                                >
                                    {t('inspections.items.attachment', { number: val.length })}
                                </Attachment>
                            );
                        }
                        return (
                            <Attachment
                                state={(val.length > 0).toString()}
                                onClick={() => onSee(val)}
                            >
                                {t('inspections.items.attachments', { number: val.length })}
                            </Attachment>
                        );
                    }
                    return (
                        <Attachment state={(val.length > 0).toString()}>
                            {t('inspections.items.non-attachment')}
                        </Attachment>
                    );
                },
            },
        },
    ] : [
        {
            name: 'photos',
            label: t('items.items.icon'),
            options: {
                customBodyRender: (val) => (
                    val.length > 0 ?
                        <div
                            role="button"
                            tabIndex={0}
                            style={{ width: 50, height: 50, borderRadius: 5, cursor: 'pointer', display: 'inline-block' }}
                            onClick={() => {
                                if (onImageClick) {
                                    onImageClick(val);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    if (onImageClick) {
                                        onImageClick(val);
                                    }
                                }
                            }}
                            aria-label="View image gallery"
                        >
                            <img
                                src={val[0]}
                                alt='Item thumbnail'
                                style={{ width: '100%', height: '100%', borderRadius: 5, objectFit: 'cover' }}
                            />
                        </div> :
                        <PhotoPlaceholder width={28} style={{ marginLeft: '10px' }} />
                ),
            },
        },
        {
            name: 'title',
            label: t('items.items.identifier'),
        },
        {
            name: 'report.conformity.id',
            label: t('inspections.info-card.complaint'),
            options: {
                customBodyRender: (val, item) => {
                    const conformity = item.value.report?.conformity?.id
                    if (conformity === undefined) return <></>
                    let text = t('inspections.items.no')
                    if (conformity === 1) {
                        text = t('inspections.items.yes')
                    } else if (conformity === 2) {
                        text = t('inspections.items.scheduled')
                    }
                    return <Validation state={conformity.toString()}>{text}</Validation>
                },
            },
        },
        {
            name: 'report.description',
            label: t('items.items.description'),
            options: {
                customBodyRender: (val, item) => (
                    <div style={{ maxHeight: '180px', overflowY: 'auto' }}>
                        {item.value.report && item.value.report.description}
                    </div>
                ),
            },
        },
        {
            name: 'report.photos',
            label: t('inspections.items.attachments', { number: '' }),
            options: {
                customBodyRender: (val, item) => {
                    const photos = item.value.report?.photos ?? []
                    console.log("Report photos value: ", photos)
                    if (photos.length > 0) {
                        if (photos.length === 1) {
                            return (
                                <Attachment
                                    state={(photos.length > 0).toString()}
                                    onClick={() => onSee(photos)}
                                >
                                    {t('inspections.items.attachment', { number: photos.length })}
                                </Attachment>
                            );
                        }
                        return (
                            <Attachment
                                state={(photos.length > 0).toString()}
                                onClick={() => onSee(photos)}
                            >
                                {t('inspections.items.attachments', { number: photos.length })}
                            </Attachment>
                        );
                    }
                    return (
                        <Attachment state={(photos.length > 0).toString()}>
                            {t('inspections.items.non-attachment')}
                        </Attachment>
                    );
                },
            },
        },
    ];
};